import { getLinkDelta } from './getLinkDelta';
export function getCorrelationDelta(correlation) {
    if (correlation.link.length > 0)
        return getLinkDelta(correlation.link[0]);
}
//# sourceMappingURL=getCorrelationDelta.js.map